import { Writable, writable } from "svelte/store";
import {
  getDistributorFulfillmentMethod,
  getSavedFulfillmentMethods,
} from "@retailer/services/fulfillment_methods_service";
import type { RetailerFulfillmentMethod } from "@shared/types/RetailerFulfillmentMethod";

const _store: Writable<Record<number, RetailerFulfillmentMethod>> = writable({});

const { subscribe, set, update } = _store;

const RetailerFulfillmentMethodsStore = {
  refreshFulfillmentMethods,
  set,
  subscribe,
  update,
  updateDistributorFulfillmentMethod,
};

async function updateDistributorFulfillmentMethod(distributorId: number): Promise<void> {
  const result = { [distributorId]: await getDistributorFulfillmentMethod(distributorId) };

  update(current => {
    Object.assign(current, result);

    return current;
  });
}

async function refreshFulfillmentMethods(): Promise<void> {
  const fulfillmentMethods = await getSavedFulfillmentMethods();

  set(fulfillmentMethods);
}

export default RetailerFulfillmentMethodsStore;
